import { jsxs as c, jsx as o, Fragment as m } from "react/jsx-runtime";
import d from "react";
import s, { css as a } from "styled-components";
import { m as i } from "../chunks/breakpoints.907eaecd.js";
import { R as x, H as f } from "../chunks/Heading.2a0f9b41.js";
import { R as v, P as h } from "../chunks/Paragraph.60dac1f9.js";
const C = s.div.withConfig({
  displayName: "CookiesPopUp",
  componentId: "sc-1v2ko5x-0"
})(["position:fixed;max-width:800px;bottom:var(--spacing-5x);left:50%;transform:translate(-50%,0);z-index:6;display:flex;gap:var(--spacing-5x);flex-direction:row;align-items:center;justify-content:space-between;width:100%;padding:var(--spacing-5x);border-radius:var(--border-radius-xl);background:var(--elements-bg-color-02);box-sizing:border-box;", " ", " ", ""], i.md(a(["margin:0 var(--spacing-5x);width:calc(100% - var(--spacing-10x));left:calc(50% - var(--spacing-5x));"])), i.sm(a(["flex-direction:column;align-items:flex-start;padding:var(--spacing-3x);gap:var(--spacing-4x);border-radius:var(--border-radius-lg);margin:0 var(--spacing-1x);width:calc(100% - var(--spacing-2x));left:calc(50% - var(--spacing-1x));"])), i.sm(a(["bottom:var(--spacing-1x);"]))), k = s.div.withConfig({
  displayName: "CookiesPopUpSlotContent",
  componentId: "sc-1v2ko5x-1"
})(["display:flex;flex-direction:column;gap:var(--spacing-1x);width:100%;gap:var(--spacing-1x);"]), u = s.div.withConfig({
  displayName: "SlotAction",
  componentId: "sc-1v2ko5x-2"
})(["", ""], i.sm(a(["width:100%;"]))), w = d.forwardRef(({
  slotContent: n,
  slotAction: e,
  ...r
}, t) => /* @__PURE__ */ c(C, { ref: t, "data-testid": "rango-cookies-pop-up", "data-rango-component": "rango-cookies-pop-up", "data-is-rango": !0, ...r, children: [
  /* @__PURE__ */ o("div", { className: "slotContent", children: n }),
  /* @__PURE__ */ o(u, { children: e })
] })), b = d.forwardRef(({
  heading: n,
  paragraph: e,
  headingProps: r,
  paragraphProps: t,
  children: p,
  ...g
}, l) => p ? /* @__PURE__ */ o(m, { children: p }) : /* @__PURE__ */ c(k, { ...g, ref: l, children: [
  /* @__PURE__ */ o(x, { ...r, size: f.XS, children: n }),
  /* @__PURE__ */ o(v, { ...t, size: h.SM, children: e })
] }));
w.displayName = "RangoCookiesPopUp";
b.displayName = "RangoCookiesPopUpSlotContent";
export {
  w as RangoCookiesPopUp,
  b as RangoCookiesPopUpSlotContent
};
